import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { registry } from '../registry';
import { connectLegacySdk } from '../lib/sdk/legacy';
import { ExtensionProvider } from '../lib/sdk';
import type { ExtensionSdk } from '../lib/sdk';
import { Shell } from '../ui/Shell';
import { errorMessage } from '../lib/errors';

/** Production route: /#/<id>, loaded by Contentstack inside an iframe. */
export function ExtensionPage() {
  const { id = '' } = useParams();
  const entry = registry[id];
  const [sdk, setSdk] = useState<ExtensionSdk | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!entry) return;
    connectLegacySdk().then(setSdk).catch((e) => setError(errorMessage(e)));
  }, [entry]);

  if (!entry) return <p className="vc-error">Unknown extension “{id}”.</p>;
  const { Component } = entry;
  if (error) return <p className="vc-error">Could not connect to Contentstack: {error}</p>;
  if (!sdk) return <p className="vc-muted">Connecting…</p>;

  return (
    <Shell>
      <ExtensionProvider sdk={sdk} meta={entry.meta}>
        <Component />
      </ExtensionProvider>
    </Shell>
  );
}
